/* eslint-disable global-require */
const Component = process.env.NODE_ENV === 'production'
  ? require('./build/cjs/index.production.js')
  : require('./build/cjs/index.development.js');

module.exports = Component.default;
exports = module.exports;
exports.CheckboxList = Component.default;
exports.CheckboxListItem = Component.CheckboxListItem;
